<template>
  <div id="search-wacana">
    <button class="btn btn-white" type="button" v-on:click="showCreateWacanaModal = true">Buat Baru</button>
    <button class="btn btn-white" type="button" v-on:click="showModal = true">Pilih</button>
    <button class="btn btn-success" type="button" v-if="wacana.id != 0" v-on:click="editWacana">Edit</button>
    <button class="btn btn-danger" type="button" v-if="wacana.id != 0" v-on:click="showConfirmation = true">
      Reset
    </button>
    <br /><br />
    <blockquote v-if="wacana.id != 0">
      <p v-html="previewWacana"></p>
    </blockquote>
    <app-modal v-if="showModal" v-on:ok="showModal = false">
      <h4 slot="header">Cari Wacana</h4>
      <div slot="body">
        <app-datatable :headers="headers" :items="wacanas" v-on:selected="wacana = {id: $event.id, content: $event.data[0]}" :numbered="false"></app-datatable>
      </div>
    </app-modal>
    <app-modal v-if="showConfirmation" v-on:ok="resetWacana">
      <h4 slot="header">Perhatian</h4>
      <div slot="body">
        <p>Apakah anda yakin ingin melepas wacana ini dari soal?</p>
      </div>
    </app-modal>
    <app-modal v-if="showCreateWacanaModal" v-on:ok="saveWacana">
      <h4 slot="header">Buat Wacana Baru</h4>
      <div slot="body">
        <app-editor :rows="8" v-on:content-updated="wacana.content = $event" :value="wacana.content"></app-editor>
      </div>
      <div slot="footer">
        <button type="button" class="btn btn-success" @click="saveWacana()">Simpan</button>
        <button type="button" class="btn btn-danger" @click="showCreateWacanaModal = false">Batal</button>
      </div>
    </app-modal>
  </div>
</template>

<script>
import Modal from '@/components/plugins/Modal'
import DataTable from '@/components/plugins/DataTable'
import MarkdownEditor from '@/components/plugins/MarkdownEditor'
import itembankService from '@/services/itembank.js'
import Marked from 'marked'
import Moment from 'moment'

export default {
  name: 'wacana',
  components: {
    'app-modal': Modal,
    'app-datatable': DataTable,
    'app-editor': MarkdownEditor,
  },
  props: ['value'],
  data: function() {
    return {
      showModal: false,
      showConfirmation: false,
      showCreateWacanaModal: false,
      headers: ['Konten', 'Created At'],
      wacanas: [],
      wacana: {id: 0, content: ''},
    }
  },
  computed: {
    previewWacana: function() {
      return Marked(this.wacana.content)
    }
  },
  methods: {
    resetWacana: function() {
      this.wacana = {id:0, content: ''}
      this.showConfirmation = false
    },
    saveWacana: function() {
      this.showCreateWacanaModal = false
      var postData = {
        mapelId: this.$route.query.mapel,
        wacana: this.wacana.content
      }

      var context = this
      if(this.wacana.id == 0) {
        itembankService.createWacana(postData, function(result){
          if(result.success) {
            context.wacana = {id: result.data.id, content: result.data.isi}
            context.loadData()
          }
        })
      } else {
        itembankService.updateWacana(this.wacana.id, postData, function(result) {
          if(result.success) {
            context.loadData()
          }
        })
      }
    },
    editWacana: function() {
      this.showCreateWacanaModal = true
    },
    loadData: function() {
      var context = this
      var mapelId = this.$route.query.mapel
      itembankService.getListWacana(mapelId, function(result) {
        if(result.success) {
          context.wacanas = []
          result.data.forEach(function(wacana) {
            var createdAt = Moment(wacana.created_at).fromNow()
            context.wacanas.push({id: wacana.id, data: [wacana.isi, createdAt]})
          })
        }
      })
    }
  },
  watch: {
    'wacana': function(val) {
      this.$emit('selected', val)
    },
    'value': function(val) {
      this.wacana = val
    }
  },
  mounted: function() {
    this.loadData()
  }
}
</script>



// WEBPACK FOOTER //
// Wacana.vue?7ff02e00